module.exports = __webpack_public_path__ + "739715d68ea53c00905fc9058c5a40cf.svg";